<script setup lang="ts">
import { computed, ref } from "vue"

import Icon from "@/components/shared/Icon.vue"
import MenuItem from "@/components/shared/MenuItem.vue"
import store from "@/plugins/store"
import type { Partner } from "@/types/partner.type"

const partner = computed<Partner | null>(() => store.getters.partner)

const newOrderCountString = computed(() => {
  let count = null
  if (partner.value && partner.value.newOrderCount > 0) count = partner.value.newOrderCount.toString()
  return count
})
const todayShipOutCountString = computed(() => {
  let count = null
  if (partner.value && partner.value.todayShipOutCount > 0) count = partner.value.todayShipOutCount.toString()
  return count
})
const newStockInquiryCountString = computed(() => {
  let count = null
  if (partner.value && partner.value.newStockInquiryCount > 0) count = partner.value.newStockInquiryCount.toString()
  return count
})

const open = ref(false)

function toggleOpen() {
  open.value = !open.value
}

defineExpose({ toggleOpen })
</script>

<template>
  <div id="side-menu" :class="{ open: open }">
    <div id="side-menu-header">
      <div class="container-fluid">
        <div class="header-box d-flex justify-content-center align-items-center">
          <a href="/" class="d-flex align-items-center">
            <Icon icon="rocket" />
            <h1>{{ $t("nav.title") }}</h1>
          </a>
        </div>
      </div>
    </div>
    <div id="side-menu-main">
      <div class="container-fluid">
        <MenuItem path="/items" icon="cart-shopping" :name="$t('nav.items')" :activeFor="['/items']" />
        <MenuItem
          path="/orders"
          icon="money-check-dollar-pen"
          :name="$t('nav.orders')"
          :badge="newOrderCountString"
          :activeFor="['/orders']"
        />
        <MenuItem
          path="/ship_outs"
          icon="truck-fast"
          :name="$t('nav.shipOuts')"
          :badge="todayShipOutCountString"
          :activeFor="['/ship_outs']"
        />
        <MenuItem path="/payouts" icon="building-columns" :name="$t('nav.payouts')" :activeFor="['/payouts']" />
        <MenuItem
          path="/swatch_stocks"
          icon="cabinet-filing"
          :name="$t('nav.swatchStocks')"
          :activeFor="['/swatch_stocks']"
        />
        <MenuItem
          path="/stock_inquiries"
          icon="comment-question"
          :name="$t('nav.stockInquiries')"
          :badge="newStockInquiryCountString"
          :activeFor="['/stock_inquiries']"
        />
        <MenuItem path="/settings" icon="gear" :name="$t('nav.settings')" :activeFor="['/settings']" />
      </div>
    </div>
  </div>
</template>

<style scoped>
#side-menu {
  position: fixed;
  top: 0;
  left: 0;
  height: calc(100vh);
  width: var(--side-menu-width);
  overflow-y: auto;
  z-index: 1000;
  background-color: #f8f6f2;
  transition: left 0.3s ease;
}

@media (max-width: 991.98px) {
  #side-menu {
    left: calc(var(--side-menu-width) * -1);
  }

  #side-menu.open {
    left: 0;
  }
}

#side-menu-header {
  height: var(--header-height);
}

#side-menu-header .container-fluid {
  height: 100%;
  padding-left: var(--container-padding);
  padding-right: var(--container-padding);
}

h1 {
  margin: 0;
  font-size: 18px;
  font-weight: 600;
}

#side-menu-main .container-fluid {
  padding: var(--container-padding);
}

.header-box a {
  text-decoration: none;
  color: #403d38;
}

.header-box {
  height: 100%;
  border-bottom: 1px solid #e0e0de;
}

.header-box i {
  margin-right: 0.35rem;
}
</style>
